
import React from 'react';
import Auth from './Auth';

const LoginPage = () => {
  return <Auth />;
};

export default LoginPage;
